import { render, staticRenderFns } from "./TypeSelect.vue?vue&type=template&id=00a4ea51&scoped=true&"
import script from "./TypeSelect.vue?vue&type=script&lang=js&"
export * from "./TypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./TypeSelect.vue?vue&type=style&index=0&id=00a4ea51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4ea51",
  null
  
)

export default component.exports